export default __webpack_public_path__ + "static/media/16.3dda68a2.jpg";